<div class="confirm-dialog card">
    <div class="card-header">
        <h2>Confirmação</h2>
    </div>
    <div class="card-body">
        <p>{{ data.message }}</p>
    </div>
    <div class="card-footer">
        <button class="btn btn-outline-secondary" (click)="onCancel()">Cancelar</button>
        <button class="btn btn-danger" (click)="onConfirm()">Remover</button>
    </div>
</div>
